import React from 'react';
import { Box, makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import Typography from '#web-components/components/Typography';
import styles from './SystemErrorDescription.styles';

interface SystemErrorDescriptionProps {
  fields: {
    name: string,
    value: string,
  }[],
  className?: string,
}

const useStyles = makeStyles(styles, { name: 'SystemErrorDescription' });

export default function SystemErrorDescription({ fields, className }: SystemErrorDescriptionProps) {
  const classes = useStyles();
  return (
    <Box className={clsx(className, classes.root)}>
      {fields.map((item) => (
        <Box key={item.name} className={classes.box}>
          <Typography variant="textSmallCompact" className={classes.name}>
            {item.name}
          </Typography>
          <Typography variant="textSmallCompact" className={classes.value}>
            {item.value}
          </Typography>
        </Box>
      ))}
    </Box>
  );
}
